import { Component, type ErrorInfo, type ReactNode } from 'react'
import { LostPoster } from './LostPoster'

interface State { failed: boolean }

/** Last line of defence: if the whole app crashes, show a calm screen with a way back instead of a blank page. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false }
  static getDerivedStateFromError(): State {
    return { failed: true }
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[mauj] The app crashed.', error, info.componentStack)
  }
  render() {
    if (!this.state.failed) return this.props.children
    return (
      <main className="crash">
        <div className="wrap nf-grid">
          <LostPoster code="Oops" />
          <div className="nf-copy">
            <div className="eyebrow">Something went wrong</div>
            <h1>We lost the map <em className="s">for a second.</em></h1>
            <p>Reloading usually fixes it. If it keeps happening, write to hello@getmauj.com.</p>
            <div className="ctas">
              <button className="btn gold" type="button" onClick={() => window.location.reload()}>Reload</button>
              <a className="btn clear" href="/">Go to the home page</a>
            </div>
          </div>
        </div>
      </main>
    )
  }
}
